import axios from "axios";
import { ElNotification } from "element-plus";
import {
  noticeUrlArr
} from '@/assets/data/noticeUrlArr'

// 用于记录时间戳的变量，时间戳是响应头中的etag和last-modified字段其中之一
let previousTimeTag = null;


export async function initCheckUpdate() {
  console.log(111111111, window.location.pathname)
  // 通过立即执行函数，记录首次请求的时间戳，以便与后面轮询得出的时间戳进行对比
  previousTimeTag = await getTimeTag();
  window.versionMonitor && clearInterval(window.versionMonitor);
  // 开启轮询执行judge函数
  window.versionMonitor = setInterval(() => {
    judge();
  }, 6 * 1000); // 每6秒轮询一次
}



if (noticeUrlArr.indexOf(window.location.pathname) !== -1) {
  initCheckUpdate()
} else { 
  clearInterval(window.versionMonitor);
}


async function getTimeTag() {
  const response = await axios(
    `${window.location.protocol}//${window.location.host}`,
    {
      method: "HEAD",
      cache: "no-cache",
    }
  );
  console.log("etag==========", response, response.headers);
  // 以响应体的etag或者last-modified为时间戳
  return response.headers["etag"] || response.headers["last-modified"];
}

async function judge() {
  // 获取当前最新的时间戳
  const currentTimeTag = await getTimeTag();
  console.log(5555555555,previousTimeTag,currentTimeTag)
  // 检测到最新请求的时间戳和上一次不一致，即文件发生变化
  if (previousTimeTag !== currentTimeTag) {
    ElNotification({
      title: "系统更新提醒",
      dangerouslyUseHTMLString: true,
      message:
        `系统已发布最新版本，请尽快进行更新以获取最佳使用体验！<span id="force-reload-btn" class="mj-link-type" >立即更新</span>`,
      type: "warning",
      duration: 0,
      offset: 60,
      onClose: () => {
        const btn = document.getElementById('force-reload-btn');
        if (btn) btn.onclick = null; // 清理事件
      }
    });

    setTimeout(() => {
      const btn = document.getElementById('force-reload-btn');
      if (btn) {
        btn.onclick = () => {
          window.location.search = '?timestamp=' + Date.now();
        };
      }
    }, 100);

    clearInterval(window.versionMonitor);
    // 这里编写更新逻辑
  }
}